import { useCallback, useEffect, useState } from "react";
import { getCountPendingReceipt } from "../service/countPendingReceipt";

export function useCountPendingRequest(cliente) {
  const [data, setData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!cliente) return;

    setLoading(true);
    setError(null);

    try {
      const res = await getCountPendingReceipt(cliente);
      setData(res);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [cliente]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    // console.log("cliente recibido:", cliente);
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh,
  };
}
